import { render, staticRenderFns } from "./BackgroundMatrix.vue?vue&type=template&id=3e968368&scoped=true"
import script from "./BackgroundMatrix.vue?vue&type=script&lang=js"
export * from "./BackgroundMatrix.vue?vue&type=script&lang=js"
import style0 from "./BackgroundMatrix.vue?vue&type=style&index=0&id=3e968368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e968368",
  null
  
)

export default component.exports